import React, { useState } from 'react';
import { Trophy } from 'lucide-react';
import { HelpLink } from './HelpLink';
import { LeadPageDrilldown } from './LeadPageDrilldown';

const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;

// Top 3 content pages by converted leads for the selected month (data computed by the backend lead report).
export const TopLeadPages = ({ pages, token, month }) => {
  const [open, setOpen] = useState(null);
  return (
  <section className="space-y-3" data-testid="lead-report-top-pages">
    <div>
      <h3 className="text-lg font-serif flex items-center gap-2"><Trophy className="w-4 h-4 text-amber-600" />Top Lead Pages <HelpLink topic="top-lead-pages" /></h3>
      <p className="text-xs text-neutral-500">Use this section to identify which website pages are generating qualified leads and completed sales activity. It can help guide future SEO, content and marketing priorities.</p>
    </div>
    {pages.length ? (
      <ol className="grid gap-2 md:grid-cols-3">
        {pages.map((p, i) => (
          <li key={p.path}>
          <button type="button" onClick={() => setOpen(p)} title="See the leads behind this page"
            className="w-full h-full text-left border border-neutral-200 rounded-lg bg-white px-4 py-3 hover:border-amber-400 hover:shadow-sm transition-[border-color,box-shadow]" data-testid={`top-page-${i + 1}`}>
            <p className="text-xs text-neutral-400">#{i + 1}</p>
            <p className="font-semibold text-neutral-900 truncate" title={p.title} data-testid={`top-page-${i + 1}-title`}>{p.title}</p>
            <p className="text-xs text-neutral-400 truncate">{p.path}</p>
            <p className="mt-2 text-sm text-neutral-800" data-testid={`top-page-${i + 1}-summary`}>{plural(p.total_leads, 'lead')} · <strong>{p.converted} converted</strong>{p.conversion_pct != null && <span className="text-neutral-500"> · {p.conversion_pct}%</span>}</p>
            <p className="text-xs text-neutral-500" data-testid={`top-page-${i + 1}-split`}>{plural(p.consultation_conversions, 'consultation conversion')} · {plural(p.quote_conversions, 'quote conversion')}</p>
            {p.quote_not_trackable > 0 && <p className="text-[11px] text-neutral-400 mt-1">{p.quote_not_trackable} quote request{p.quote_not_trackable === 1 ? '' : 's'} not trackable yet (left out of the rate)</p>}
            <p className="mt-2 text-[11px] text-amber-700">View leads →</p>
          </button>
          </li>
        ))}
      </ol>
    ) : <p className="text-sm text-neutral-500 border border-dashed rounded-lg px-4 py-6 text-center" data-testid="top-pages-empty">No website page had a converted lead this month yet.</p>}
    {pages.length > 0 && pages.length < 3 && <p className="text-xs text-neutral-500" data-testid="top-pages-note">Only pages with at least one conversion are shown for this month.</p>}
    <p className="text-[11px] text-neutral-400">Ranked by converted leads, then conversion rate. Rate = converted ÷ (consultations + trackable quote requests). Direct visits and records without a source are left out here but still counted in the sections below.</p>
    <LeadPageDrilldown token={token} month={month} page={open} onClose={() => setOpen(null)} />
  </section>
  );
};
